type UnifiedCheckoutGuardState = {
  draftOrderCount: number;
  paidOrderCount: number;
  pendingOrderCount: number;
  failedOrderCount: number;
  isOverviewPage: boolean;
  isSuccessPage: boolean;
};

export const getUnifiedCheckoutGuardRedirect = ({
  draftOrderCount,
  paidOrderCount,
  pendingOrderCount,
  failedOrderCount,
  isOverviewPage,
  isSuccessPage,
}: UnifiedCheckoutGuardState): "success" | "overview" | "checkout" | null => {
  if (
    draftOrderCount === 0 &&
    paidOrderCount > 0 &&
    pendingOrderCount === 0 &&
    failedOrderCount === 0 &&
    !isSuccessPage
  ) {
    return "success";
  }

  const hasCreatedOrders =
    paidOrderCount > 0 || pendingOrderCount > 0 || failedOrderCount > 0;
  if (draftOrderCount === 0 && !hasCreatedOrders && !isOverviewPage) {
    return "overview";
  }

  if (draftOrderCount > 0 && isSuccessPage) return "checkout";

  return null;
};
